
@if(transport().stopDetails) {
  <button 
    class="ci-caption-regular transfer__see-stop-details"
    (click)="handleClickSeeStopDetails()"
  >
  {{ 'Ver indicaciones' | translate }}
  </button>
}